import {
  type FC
} from 'react';
import {
  styled,
  Stack,
  Typography,
} from '@mui/joy';

const TitleText = styled(Typography)(({ theme }) => ({
  fontSize: 20,
  fontWeight: 700,
  lineHeight: '24px',
  fontStyle: 'normal',
  color: theme.palette.common.white
}));

const SubtitleText = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '24px',
  fontStyle: 'normal',
  color: theme.palette.common[150]
}));

const SubtitleLinkText = styled('span')(({ theme }) => ({
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '32px',
  fontStyle: 'normal',
  textUnderlineOffset: 'auto',
  textDecorationStyle: 'solid',
  textDecorationSkipInk: 'none',
  textDecorationThickness: 'auto',
  textDecorationLine: 'underline',
  textUnderlinePosition: 'from-font',
  color: theme.palette.common[300],
  ['&:hover']: { cursor: 'pointer' }
}));

export type TitleBlockProps = {
  onSupportContact?(): void;
};

export const TitleBlock: FC<TitleBlockProps> = ({ onSupportContact }) => (
  <Stack
    width='100%'
    rowGap={1.5}
    alignItems='center'
    justifyContent='center'>
    <Stack
      rowGap={0.5}
      alignItems='center'
      justifyContent='center'>
      <TitleText>
        The transaction failed
      </TitleText>
      <SubtitleText>
        Please contact&nbsp;<SubtitleLinkText onClick={onSupportContact}>support</SubtitleLinkText>,&nbsp;or try again
      </SubtitleText>
    </Stack>
  </Stack>
);